/*
 * NextGenn engine · plants and places (sections/ngs-places.liquid).
 *
 * The one thing that makes the map worth drawing: the selection is SHARED
 * between a point and its card, in both directions. Tap a place on the map and
 * its card comes to you and lifts; tap a card and its point fills.
 *
 * Everything else is already in the HTML. Without this file every card is
 * still a card and every point is still a button — the scene is complete, and
 * this only makes the two halves one.
 */
if (!customElements.get('ngs-places')) {
  customElements.define(
    'ngs-places',
    class NgsPlaces extends HTMLElement {
      connectedCallback() {
        this.points = Array.from(this.querySelectorAll('.ngs-map__point'));
        this.cards = Array.from(this.querySelectorAll('.ngs-places__card'));
        if (!this.points.length || !this.cards.length) return;

        this.picked = '';
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const point = event.target.closest('.ngs-map__point');
        if (point) {
          /* A second tap on the same place lets it go, so the rail comes back
             to full strength without hunting for a way out. */
          const place = point.dataset.place;
          this.pick(place === this.picked ? '' : place, point.dataset.card);
          return;
        }

        /* A tap on a card picks it too — but never steals a tap meant for a
           chip, which is a link to a bottle. */
        const card = event.target.closest('.ngs-places__card');
        if (!card || event.target.closest('a')) return;
        const place = card.dataset.place;
        this.pick(place === this.picked ? '' : place, null);
      }

      pick(place, cardId) {
        this.picked = place;
        if (place) this.dataset.picked = place;
        else this.removeAttribute('data-picked');

        this.points.forEach((p) => p.setAttribute('aria-pressed', String(Boolean(place) && p.dataset.place === place)));
        this.cards.forEach((c) => c.toggleAttribute('data-on', Boolean(place) && c.dataset.place === place));

        /* Only a tap on the MAP moves the page: a tap on a card must not pull
           the card the reader is already looking at out from under the thumb. */
        if (!place || !cardId) return;
        const card = document.getElementById(cardId);
        if (!card) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        /* The rail scrolls sideways on a phone, the page does not. */
        const rail = card.parentElement;
        if (rail && rail.scrollWidth > rail.clientWidth + 8) {
          rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        } else {
          card.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
        }
      }
    }
  );
}
